export function checkConcentration(scores) {
  const totalValue = scores.reduce((sum, s) => sum + (s.position_value || 0), 0);
  if (totalValue <= 0) return [];

  const alerts = [];
  scores.forEach(s => {
    const weight = ((s.position_value || 0) / totalValue) * 100;
    if (weight > 25) {
      alerts.push({ type: 'concentration', severity: 'high', message: `${s.symbol} is ${weight.toFixed(0)}% of portfolio - consider trimming` });
    }
  });
  return alerts;
}

export function checkConvictionDistribution(scores) {
  if (scores.length < 3) return [];
  const lowConviction = scores.filter(s => (s.combined_conviction || 0) < 48);
  if (lowConviction.length > scores.length * 0.5) {
    return [{ type: 'quality', severity: 'medium', message: `${lowConviction.length} of ${scores.length} positions score Unfavorable (below 48)` }];
  }
  return [];
}

export function getAllAlerts(scores) {
  return [
    ...checkConcentration(scores),
    ...checkConvictionDistribution(scores),
  ];
}
